




import enterpriseTemplate from "./templates/enterpriseTemplate.vue";
import doctorTemplate from "./templates/doctorTemplate.vue";
import businessTemplate from "./templates/businessTemplate.vue";
export default {
  name: "aiwen-register-pc",
  components: {
    enterpriseTemplate,
    doctorTemplate,
    businessTemplate
  },
  computed: {
    currentComponent() {
      console.log((this as any).$attrs, "this.$attrs init");
      interface IbusinessTypeObj {
        [propName: string]: any;
      }
      const businessTypeObj: IbusinessTypeObj = {
        biz: "enterpriseTemplate",
        doctor: "doctorTemplate",
        business: "businessTemplate"
      };
      return businessTypeObj[(this as any).$attrs.config.businessType];
    }
  }
};
